(function () {
    'use strict';

    angular
        .module('invesfleet')
        .factory('fleet', fleet);

    fleet.$inject = [
        '$http',
        '$q',
        '$timeout',
        'endPoints',
        'authorization', 
        'genericDataService',
        '$rootScope',
        'audioService',
        '$filter',
        'chat',
        'aceptacionServicioService',
        'styleMapService'
    ];

    /* jshint maxparams:false */
    function fleet(
        $http,
        $q,
        $timeout,
        endPoints,
        authorization, 
        genericDataService,
        $rootScope,
        audioService,
        $filter,
        chat,
        aceptacionServicioService,
        styleMapService
    ) {
		var service = {
			optionsStyleMaps: styleMapService.getOptionsStyleMaps(),
			getMapData: getMapData,
			getNewLogisticsCount: getNewLogisticsCount,
            getActiveOrderById: getActiveOrderById,
			getRecorrido: getRecorrido,
			getAseguradoras: getAseguradoras,
			updateConnexionEmpresaMaster: updateConnexionEmpresaMaster,
			updateAseguradorasConnexion: updateAseguradorasConnexion,
			mapData: null,
			aseguradorasData: null,
			empresaMasterData: null,
            lastUpdated: null,
            live: false,
            activeOrders: null,
            activeOrdersNumbers: {
                new: 0,
                newOrNotification: 0,
                newWithTime: 0,
                delay: 0,
                active: 0,
                pendientes: 0,
                delayNotSeen: 0,
                scheduled: 0,
				todayScheduled: 0,
				newLogistic: 0,
				movePending: 0,
            },
            unreadMessages: null,
            unreadMessagesCount: null,
            getAssignableOperators: getAssignableOperators,
			getActiveOrders: getActiveOrders, 
			getAllActiveLogistic: getAllActiveLogistic,
            canContinue: false,
            activeOrdersList: null  
        };

        var refreshInterval = 10000; //10 seconds

		$rootScope.$on('ReloadOrdenesActivas', function (event, args) {
			// getFleetData();
        });

        $(window).on('messaging-active-orders-count', function (e, args) {
            service.activeOrdersNumbers.active = args;
        });

        $(window).on('messaging-news-orders-count', function (e, args) {
            service.activeOrdersNumbers.new = args;
        });

        $(window).on('messaging-news-notifications-orders-count', function (e, args) {
            service.activeOrdersNumbers.newOrNotification = args;
        });

        $(window).on('messaging-delayed-orders-count', function (e, args) {
            service.activeOrdersNumbers.delay = args;
        });

        $(window).on('messaging-scheduled-orders-count', function (e, args) {
            service.activeOrdersNumbers.todayScheduled = args;
            service.activeOrdersNumbers.scheduled = args;
		});

		$(window).on('messaging-movepending-orders-count', function (e, args) {
			service.activeOrdersNumbers.movePending = args;
		});

        $(window).on('login-succeed', function (e) {
            service.live = true;
            $rootScope.$apply();
        });

        $(window).on('login-failed', function (e) {
            service.live = false;
            $rootScope.$apply();
        });

        $(window).on('messaging-unread-messages-count', function (e, args) {
            service.unreadMessagesCount = args;
            $rootScope.$apply();
        });


        //init
        (function () {
            // refresher();
        })();
        
        return service;

        function getMapData(companyId) {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.fleet.getMapData + (companyId ? '/?companyId=' + companyId : '')
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                //service.live = true;
                service.lastUpdated = Date.NewDate();
                updateOperatorsFromFleetdata(response.data.fleet);
                service.mapData = {
                    fleet: response.data.fleet
                };
                //cancontinue sustitutes live in order to skip map error undefined
                service.canContinue = true; 
                $rootScope.$broadcast('fleetdata-refreshed');
                deferred.resolve(response.data);
            },
            function (response) {
				//if (service.live) { alert('No hay connexión a internet'); }
                //service.live = false;
                deferred.reject(null);
            });
            return deferred.promise;
        }

        function getActiveOrders() {
            //tiene que aplicar filtro de activa? 
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.fleet.getActiveOrders
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(filterActiveOrders(response.data));
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
		}

		function getAllActiveLogistic() {
			var deferred = $q.defer();
			var request = {
				method: 'GET',
				url: endPoints.orders.getAllActiveLogistic
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
				deferred.resolve(response.data);
			},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;
		}

        function getActiveOrderById(orderId) {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.fleet.getActiveOrderById + ('?orderId=' + orderId)
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response.data[0]);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function getAseguradoras() {
			var deferred = $q.defer();
			var request = {
				method: 'GET',
				url: endPoints.aseguradoras.getAseguradoras 
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
				var aseguradorasByInsurname = computeAseguradorasByGroup(response.data);
				service.aseguradorasData = {
					aseguradoras: aseguradorasByInsurname,
					color: computeColorConnexion(response.data)
				};
				deferred.resolve(response.data);
			},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;
		}

		function getConnexionEmpresaMaster() {
			var deferred = $q.defer();
			var request = {
				method: 'GET',
				url: endPoints.aseguradoras.getConnexionEmpresaMaster
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
				service.empresaMasterData = {
					empresaMaster: response.data,
					color: computeColorEmpresaMaster(response.data)
				};
				deferred.resolve(response.data);
			},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;
		}

		function getNewLogisticsCount() {
			var deferred = $q.defer();
			var request =
			{
				method: 'GET',
				url: endPoints.orders.getNewLogisticsCount
			};
			$http(request).then(function (response) {
				deferred.resolve(response.data);
			},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;
		}

        function getAssignableOperators(orderId) {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.fleet.getAssignableOperators + '?orderId=' + orderId
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response.data);
            },
            function (response) {
                deferred.reject(null);
            });
            return deferred.promise;
        }

        var lastActiveOrders = [];
        var lastOnlineFleet = [];
        function refresher() {
            getFleetData();
            $timeout(refresher, refreshInterval);
        }

        function getFleetData() {
            $rootScope.$broadcast('heartbeat-pulse');
            lastActiveOrders = service.activeOrders;
            if(service.mapData) {
                lastOnlineFleet = $filter('filter')(service.mapData.fleet, {
                    'isOnline': true
                });
            }
            getMapData().then(function () {
                notifyOperatorOnline();
                notifyStateChanges();
                notify();
			});
			
			// getConnexionEmpresaMaster().then(function (res) { 
            //     getAseguradoras();
            // });
        }

        function notify(){
            if(chat.getNewMsgCount() > 0){
                audioService.notification.msg();
            }
            if(service.activeOrdersNumbers.new > 0){
                audioService.notification.nuevas();
            }
            if(service.activeOrdersNumbers.delayNotSeen > 0){
                audioService.notification.demora();
            }
            if(service.activeOrdersNumbers.pendientes > 0){
                audioService.notification.pendientes();
            }
        }

        function notifyStateChanges(){
            /* jshint maxcomplexity: false */
            if (lastActiveOrders === null) {
                return;
            }
            
            angular.forEach(service.activeOrders, function(order, index) {
                var o = $filter('filter')(lastActiveOrders, {'orderId': order.orderId});
                if(o.length > 0){
                    if(o[0].state !== order.state){ //STATE CHANGE

                        order.stateChanged = true;

                        switch(order.state){
                            case 1: //ASIGNADO 
                                audioService.notification.asignado();
                                break;
                            case 2: //ACEPTADO
                                audioService.notification.aceptado();
                                break;
                            case 6: //ENTREGADO
                                audioService.notification.entregado();
                                break;
                            case 3: //RECHAZADO
                                audioService.notification.rechazado();
                                break;
                            case 4: //INICIADO
                                audioService.notification.iniciado();
                                break;
                            case 5: //LOCALIZADO
                                audioService.notification.localizado();
                                break;
                            case 10: //FINALIZADO
                                audioService.notification.finalizado();
                                break;
                        }
                    }
                } else if(order.programada){
                    order.stateChanged = true;
                    audioService.notification.programadas();
                } else if(order.grouping === 0){
                    order.stateChanged = true;
                    aceptacionServicioService.newOrderNotification(order);
                }
            });
        }

        function notifyOperatorOnline(){
            if(!lastOnlineFleet) {return;}
            
            var fleet = $filter('filter')(service.mapData.fleet, {'isOnline': true});
            angular.forEach(fleet, function(vehicle, index) {
                var v = $filter('filter')(lastOnlineFleet, {'operatorId':vehicle.operatorId});
                if(v.length <= 0){
                    audioService.notification.opOnline();
                }
            });
        }

        function filterMapOrders(orders){
            var ordersMapa = [];

   //         service.activeOrdersNumbers = {
   //             'new': 0,
   //             'newWithTime': 0,
   //             'delay': 0, 
   //             'active': 0,
   //             'pendientes': 0,
   //             'delayNotSeen': 0
			//};
			angular.forEach(orders, function (order, index) {
				
                if (order.isMapa && order.state !== 10) {
                    ordersMapa.push(order);
                }
    //            if (order.isActive && order.grouping !== 3) {
    //                service.activeOrdersNumbers.active++;
    //            }
    //            if (order.isActive && order.grouping === 0) {
    //                service.activeOrdersNumbers.active--;
    //                service.activeOrdersNumbers.new++;

    //                if(order.timeAsignation - 
    //                    parseInt((Date.NewDate().getTime() - new Date(order.stateDate).getTime())/1000) > 0)
    //                { 
    //                    service.activeOrdersNumbers.newWithTime++; 
    //                }
    //            }
    //            if (order.isActive && (order.tiempoRestante < 0)) { //order.viewDelay && 
    //                service.activeOrdersNumbers.delay++;
    //                if(!order.viewDelay){
    //                    service.activeOrdersNumbers.delayNotSeen++;
    //                }
				//}
    //            if (order.isActive && order.assignmentState === 100 && order.state === 0){ //PENDIENTES
    //                service.activeOrdersNumbers.pendientes++;
    //            }

            });
            return ordersMapa;
        }

        function filterActiveOrders(orders){
            var ordersActive = [];
            angular.forEach(orders, function(order, index) {
                if (order.isActive) {
                    ordersActive.push(order);
                }
            });
            return ordersActive;
        }

        function updateOperatorsFromFleetdata(fleetData) {
            genericDataService.getOperarios().then(function (data) {
                for (var i = 0; i < data.length; i++) {
                    if (fleetData.find(function (cur, index, arr) {
                        if (cur.idOperator === data[i].shortId) {
                            data[i].fleetElement = cur;
                            data[i].operatorStateId = cur.operatorStateId;
                            data[i].stateDate = cur.operatorStateDate;
                            return true;
                        }
                        return false;
                    }) === undefined) {
                        data[i].fleetElement = undefined; //we however do not change the state
                    }
                }
            });
        }

        function getRecorrido(fleetId, start, finish){
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.fleet.getRecData + '?flotaId=' + fleetId + '&start=' + start + '&finish=' + finish
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response.data);
            },
            function (response) {
                deferred.reject(null);
            });
            return deferred.promise;
		}

		function updateAseguradorasConnexion(aseguradora) {
			var deferred = $q.defer();
			var request = {
				method: 'POST',
				url: endPoints.aseguradoras.updateAseguradorasConnexion,
				data: aseguradora
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
				// getConnexionEmpresaMaster().then(function (res) { 
                //     getAseguradoras();
                // });
				deferred.resolve(response.data);
			},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;
		}

		function updateConnexionEmpresaMaster() {
			var deferred = $q.defer();
			var request = {
				method: 'POST',
				url: endPoints.aseguradoras.updateConnexionEmpresaMaster
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
				// getConnexionEmpresaMaster().then(function (res) { 
                //     getAseguradoras();
                // });
				deferred.resolve(response.data);
			},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;
		}


		function computeColorConnexion(aseguradorasList) {
            /*jshint maxcomplexity:false */
			var color = 'grey';
			var anyConnected = false;
            var anyNotConnected = false;
			if (service.empresaMasterData.color === 'grey') { return color; }
			for (var i = 0; i < aseguradorasList.length; ++i) {
				if (aseguradorasList[i].companyName === 'RACC') {
					anyConnected = true;
				}
				else if (aseguradorasList[i].companyName !== 'COLABORADOR' ) { 
					if (aseguradorasList[i].isConnected) {
						anyConnected = true;
					}
					if (!aseguradorasList[i].isConnected) {
						anyNotConnected = true;
					}
				}
			}
			if (anyConnected && anyNotConnected) {
				color = 'orange';
			}
			else if (anyConnected) {
				color = 'green';
			}
			else if (anyNotConnected) {
				color = 'red';
			}
			return color;
		}

		function computeAseguradorasByGroup(aseguradorasList) {
            var aseguradorasByDistincInsurname = aseguradorasList.map(item => item.insurerName)
                .filter((value, index, self) => self.indexOf(value) === index);
			var aseguradorasByGroup = [];
			for (var i = 0; i < aseguradorasByDistincInsurname.length; ++i) {
				var insurerName = aseguradorasByDistincInsurname[i];
				var stateAseguradora = computeStateAseguradora(insurerName, aseguradorasList);
				var editableAseguradora = computeEditableAseguradora(insurerName, aseguradorasList);
				var colorAseguradora = computeColorAseguradora(insurerName, aseguradorasList);
				var asegId = computeStateAseguradoraId(insurerName, aseguradorasList);
				aseguradorasByGroup.push({
					'asegId': asegId,
					'insurerName': insurerName,
					'state': stateAseguradora,
					'editable': editableAseguradora,
					'color': colorAseguradora
				});
			}
			return aseguradorasByGroup;
		}

		function computeStateAseguradora(insurerName, aseguradorasList) {
			for (var i = 0; i < aseguradorasList.length; ++i) {
				if (aseguradorasList[i].insurerName === insurerName) {
					return aseguradorasList[i].state;
				}
			}
		}

		function computeStateAseguradoraId(insurerName, aseguradorasList) {
			for (var i = 0; i < aseguradorasList.length; ++i) {
				if (aseguradorasList[i].insurerName === insurerName) {
					return aseguradorasList[i].insurerId;
				}
			}
		}

		function computeEditableAseguradora(insurerName, aseguradorasList) {
			for (var i = 0; i < aseguradorasList.length; ++i) {
				if (aseguradorasList[i].insurerName === insurerName) {
					return aseguradorasList[i].editable;
				}
			}
		}

		function computeColorAseguradora(insurerName, aseguradorasList) {
            /*jshint maxcomplexity:false */
			var color = 'grey';
			var anyConnected = false;
			var anyNotConnected = false;
			for (var i = 0; i < aseguradorasList.length; ++i) {
				if (aseguradorasList[i].insurerName === insurerName) {
					if (aseguradorasList[i].state) {
						if (aseguradorasList[i].insurerName === 'RACC') {
							return 'green';
						}
						if (aseguradorasList[i].isConnected) {
							anyConnected = true;
						}
						if (!aseguradorasList[i].isConnected) {
							anyNotConnected = true;
						}
					}
				}
			}
			if (anyConnected && anyNotConnected) {
				color = 'orange';
			}
			else if (anyConnected) {
				color = 'green';
			}
			else if (anyNotConnected) {
				color = 'red';
			}
			return color;
		}

		function computeColorEmpresaMaster(data) {
			var color = 'grey';
			if (data.conexionAseguradoraOn) {
				color = 'green';
			}
			return color;
        }

    }
})();